import React, { useState } from 'react';
import { Upload, Button, App } from 'antd';
import type { UploadFile, UploadProps } from 'antd'
import { UploadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next'

type Props = UploadProps & {
    value?: any;
    onChange?: any,
    fileName?: string
}

const CustomUpload: React.FC<Props> = (props) => {
  const { message } = App.useApp();
  const { onChange, fileName } = props;
  const { t } = useTranslation()

  const handleChange: UploadProps['onChange'] = (info) => {
    const fileStatus = info.file?.status
    console.log('handleChange info', info);
    // if (info.file) {
    //   switch (fileStatus) {
    //     case 'uploading':
    //     case 'done':
    //       newFileList = info.fileList
    //       break;
    //     case 'removed':
    //     case 'error':
    //     default:
    //       newFileList = []
    //   }
    // }
    onChange?.(info.fileList.length ? info : null)
  };

  const defaultParams = {
    maxCount: 1,
    ...props,
    onChange: handleChange,
    // 默认支持手动上传
    beforeUpload: file => {
      // TODO:需要产品给出文件类型校验不过的提示文案
      const errorMessage = '文件名称或类型错误，请重新选择文件'
      if (file.name !== fileName) {
        file.status = 'error',
        file.response = errorMessage
        file.error = {
          statusText: errorMessage,
          message: errorMessage
        }
      }
      return false
  },
    fileList: props?.value?.fileList || [],
  }

  return (
    <Upload {...defaultParams}>
      <Button icon={<UploadOutlined />}>{t('dict.selectFile')}</Button>
    </Upload>
  );
};

export default CustomUpload;